import styled from "styled-components";

const LoginMedia = {
  desktop: "@media(min-width: 768px)",
};

export const ContainerLogin = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #000000;
  ${LoginMedia.desktop} {
    img {
      width: 145px;
      height: 20px;
    }
  }
`;

export const FormLogin = styled.form`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  width: 300px;
  height: 400px;
  background: #212529;
  box-shadow: 0px 3.20867px 32.0867px -8.02168px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  ${LoginMedia.desktop} {
    width: 370px;
    height: 450px;
  }

  h1 {
    margin-top: 33px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 22px;
    color: #f8f9fa;
    ${LoginMedia.desktop} {
      font-size: 18px;
      line-height: 28px;
    }
  }

  input {
    width: 265px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 14px;
    background: #343b41;
    border: 0.9px solid #f8f9fa;
    box-sizing: border-box;
    border-radius: 3.5px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #f8f9fa;
    margin-top: 8px;
    ${LoginMedia.desktop} {
      width: 330px;
      height: 48px;
      font-size: 17px;
      line-height: 26px;
    }
  }

  label {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 0px;
    color: #f8f9fa;
    ${LoginMedia.desktop} {
      font-size: 12px;
    }
  }

  p {
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    color: #868e96;
    margin: 15px 0px 17px 0px;
    ${LoginMedia.desktop} {
      font-size: 12px;
      line-height: 18px;
    }
  }

  span {
    color: red;
    font-size: 10px;
    ${LoginMedia.desktop} {
      font-size: 12px;
    }
  }
`;

export const FormButton1 = styled.button`
  width: 260px;
  height: 40px;
  background: #ff577f;
  border: 1.3px solid #ff577f;
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 21px;
  color: #f8f9fa;
  cursor: pointer;
  margin-top: 10px;
  ${LoginMedia.desktop} {
    width: 325px;
    height: 48px;
    font-size: 16px;
    line-height: 26px;
  }
`;
export const FormButton2 = styled(FormButton1)`
  background: #868e96;
  border: 1.2182px solid #868e96;
  ${LoginMedia.desktop} {
    width: 325px;
    height: 48px;
    font-size: 16px;
    line-height: 26px;
  }
`;
